import Vue from 'vue'
import VueHead from 'vue-head'
import Router from 'vue-router'
import {canUsed} from 'gkSrc/utils/local.storage'
import utils from '../utils/'
import store from '../store/'
import state from '../store/state'
import sensorsReport from '../utils/sensors.report'

const PageEvent = resolve => require(['@/view/event/Event.vue'], resolve)
const PageForm = resolve => require(['@/view/form/Form.vue'], resolve)
const PageNotFound = resolve => require(['@/view/404'], resolve)
// html head meta
Vue.use(VueHead)

Vue.use(Router)

// 表单示例：https://www.infoq.cn/form/?id=172
// 活动示例：https://www.infoq.cn/event/?id=172

const router = new Router({
  mode: 'history',
  routes: [
    { name: 'event', path: '/event/', component: PageEvent },
    { name: 'form', path: '/form/', component: PageForm },
    { name: 'notFound', path: '/404', component: PageNotFound, meta: {title: '找不到相关内容'} }
  ]
})

router.beforeEach((to, from, next) => {
  utils.initWxConfig()
  .then(() => {}).catch(() => {})
  .finally(() => {
    let common = sensorsReport.common
    let utmParams = {}
    Object.keys(common).forEach(key => {
      if (key.indexOf('utm_') === 0 && common[key]) utmParams[key] = common[key]
    })

    let gkSource = from.query.gk_source || utils.getQueryString(document.referrer, 'gk_source')
    if (gkSource) utmParams.gk_source = gkSource
    let sign = from.query.sign || utils.getQueryString(document.referrer, 'sign')
    if (sign) utmParams.sign = sign

    let query = Object.assign({}, utmParams, from.query, to.query)

    if (utils.isEqual(query, to.query)) {
      next()
    } else {
      next({ path: to.path, query, hash: to.hash })
    }
  })
})

router.beforeResolve((to, from, next) => {
  if (!canUsed) {
    Vue.prototype.$modal.message({
      title: '异常提示',
      message: '您的浏览器已禁用cookie功能，会影响部分网站功能的使用，建议打开。',
      okBtnColor: 'dialogBlue',
      center: state.isMobile,
      width: state.isMobile ? 300 : 500
    })
  }

  // 获取缓存中未执行的需要登录后的操作(获取登录信息)
  store.dispatch('getSigninInfo').then(res => {
    sensorsReport.init(res)
    sensorsReport.setLogin(res, res.uid)
    next()
  }).catch(() => {
    sensorsReport.init(false)
    sensorsReport.setLogin(false)
    next()
  })
})
export default router
